import http from "@/request/index.ts";

export default class HomeApi {
  /**
   * 获取友情链接
   */
  static async getFriendLink() {
    let res = await http.get("/link/list");
    return res.data;
  }

  /**
   * 获取ossInfo
   */
  static async getOssInfo() {
    let res = await http.get("/sysOss/sts", {}, { timeout: 10000 });
    return res;
  }

  /**
   * 增加官网浏览
   */
  static async addHomeBrower() {
    let res = await http.post("/view/save");
    return res;
  }
}
